var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DCP-Manage-Rides",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-253.000000, -487.000000)",
    fill: "#D32F2F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_circle_checkmark",
    transform: "translate(253.000000, 487.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,13.6666667 C3.31810167,13.6666667 0.333333333,10.6818983 0.333333333,7 C0.333333333,3.31810167 3.31810167,0.333333333 7,0.333333333 C10.6818983,0.333333333 13.6666667,3.31810167 13.6666667,7 C13.6666667,10.6818983 10.6818983,13.6666667 7,13.6666667 Z M7.66666667,7.66666667 L7.66666667,3 L6.33333333,3 L6.33333333,7.66666667 L7.66666667,7.66666667 Z M6.33333333,9.67099567 C6.33333333,9.86435883 6.39446181,10.0230874 6.5167206,10.1471861 C6.6389794,10.2712849 6.80079008,10.3333333 7.0021575,10.3333333 C7.20064824,10.3333333 7.3610206,10.2712849 7.4832794,10.1471861 C7.60553819,10.0230874 7.66666667,9.86435883 7.66666667,9.67099567 C7.66666667,9.47474649 7.60481903,9.31385344 7.4811219,9.18831169 C7.35742477,9.06276994 7.19777156,9 7.0021575,9 C6.80366675,9 6.64257523,9.06276994 6.5188781,9.18831169 C6.39518097,9.31385344 6.33333333,9.47474649 6.33333333,9.67099567 Z",
    id: "shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLate);
export default __webpack_public_path__ + "static/media/late.81a7b4d181919fac3dd18c9418d4a48f.svg";
export { ForwardRef as ReactComponent };